import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import set from 'lodash/set';

const NEWS_INIT = 'company/news/INIT';
export const newsInit = createAction(NEWS_INIT);

const NEWS_GET_DATA = 'company/news/GET_NEWS';
export const newsGetData = createAction(NEWS_GET_DATA, api.getCompanyNews);

const NEWSVIEW_INIT = 'company/newsView/INIT';
export const newsviewInit = createAction(NEWSVIEW_INIT);

const NEWSVIEW_RESET_DATA = 'company/newsView/RESET_DATA';
export const newsviewResetData = createAction(NEWSVIEW_RESET_DATA);

const NEWSVIEW_GET_DATA = 'company/newsView/GET_DATA';
export const newsviewGetDATA = createAction(NEWSVIEW_GET_DATA, api.getCompanyNewsView);

const MEDIA_INIT = 'company/media/INIT';
export const mediaInit = createAction(MEDIA_INIT);

const MEDIA_GET_DATA = 'company/media/GET_MEDIA';
export const mediaGetData = createAction(MEDIA_GET_DATA, api.getCompanyMedia);

const initialState = {
	news: {
		isInit: false,
		isNone: false,
		listData: [],
		totalCount: 0,
	},
	newsview: {
		isInit: false,
		viewData: null,
	},
	media: {
		isInit: false,
		isNone: false,
		listData: [],
		totalCount: 0,
	},
};

export default handleActions(
	{
		[NEWS_INIT]: (state, action) =>
			produce(state, (draft) => {
				set(draft, ['news', 'isInit'], action.payload);
			}),

		[NEWSVIEW_INIT]: (state, action) =>
			produce(state, (draft) => {
				set(draft, ['newsview', 'isInit'], action.payload);
			}),

		[MEDIA_INIT]: (state, action) =>
			produce(state, (draft) => {
				set(draft, ['media', 'isInit'], action.payload);
			}),

		...pender({
			type: NEWS_GET_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { list, totalCount } = data;
					set(draft, ['news', 'listData'], list || []);
					set(draft, ['news', 'isNone'], list.length === 0);
					set(draft, ['news', 'totalCount'], totalCount);
				}),
		}),

		...pender({
			type: NEWSVIEW_GET_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, ['newsview', 'viewData'], data || {});
				}),
		}),

		...pender({
			type: MEDIA_GET_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { list, totalCount } = data;
					set(draft, ['media', 'listData'], list || []);
					set(draft, ['media', 'isNone'], list.length === 0);
					set(draft, ['media', 'totalCount'], totalCount);
				}),
		}),
	},
	initialState,
);
